import React, { useContext } from 'react';
import { AuthContext } from '../../../../shared/context/auth-context';
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min';



import './mendItem.css';

const MendItem = mends => {
  const auth = useContext(AuthContext);

  return (
    <main>   
      <div className='main-mend-container'>
        <NavLink to={`/mend/${mends.id}`} style={{textDecoration:'none'}}>
          <div className='mend-img'>
            <img src={`${process.env.REACT_APP_ASSET_URL}/${mends.image}`} alt={mends.name}/>
          </div>
            
          <div className='mend-text-container'>
            <h3>{mends.title}</h3>
            <p style={{fontWeight: 'bold'}}>{mends.createdAt}</p>     
          </div>      
        </NavLink>

        {/* Only Visible for Admin */}
        {auth.isLoggedIn && auth.user && auth.user.role === 'admin' && (  
          <NavLink to={`/updateMend/${mends.id}`} style={{textDecoration:'none'}}>
            Edit
          </NavLink>
        )}
      </div>
      <hr className='hr-style'/>
    </main>
  )
}
export default MendItem;